// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"a6841ddf","619":"42313c6a","702":"a8d5fb1a","709":"5a1c3ed5","979":"8bbdec38"}[chunkId] + ".chunk.js";
};